import markDownIt from "markdown-it";
function markdownToHtml(text, inline) {
  if (!text) {
    return "";
  }
  const md = markDownIt({
    breaks: true,
    // convert '\n' in paragraphs into <br>
    linkify: true
    // convert URL-like text to links
  });
  md.renderer.rules.link_open = (tokens, idx, options, env, self) => {
    var _a;
    const attributes = {
      target: "_blank",
      rel: "noopener noreferrer"
    };
    const href = (_a = tokens[idx].attrs) == null ? void 0 : _a[tokens[idx].attrIndex("href")][1];
    if (href == null ? void 0 : href.match(/^https?:\/\//)) {
      Object.keys(attributes).forEach((attr) => {
        var _a2, _b;
        const attrKey = attr === "className" ? "class" : attr;
        const attrValue = attributes[attr];
        const attrIndex = tokens[idx].attrIndex(attrKey);
        if (attrIndex < 0) {
          tokens[idx].attrPush([attrKey, attrValue]);
        } else if ((_b = (_a2 = tokens == null ? void 0 : tokens[idx]) == null ? void 0 : _a2.attrs) == null ? void 0 : _b[attrIndex][1]) {
          const tokenAttrs = tokens[idx].attrs;
          if (tokenAttrs) {
            tokenAttrs[attrIndex][1] = attrValue;
          }
        }
      });
    }
    return self.renderToken(tokens, idx, options);
  };
  const res = inline ? md.renderInline(text) : md.render(text);
  return res;
}
export {
  markdownToHtml
};
